import styled from 'styled-components'

export const LoadingScreen = styled.div`
	padding: 2rem;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
`
